import { FC, PropsWithChildren } from 'react';

import { Navigate } from 'react-router-dom';

import { useAppSelector } from '@/shared/lib/redux';

import { ACTOR_ROUTES } from '@/shared/constants';

/**
 * Guard для страниц видеочитки, где требуется выбранный отрывок
 * @param root0 Прпсы
 * @param root0.children Доченрние элементы
 */
export const VideoReadingGuard: FC<PropsWithChildren> = ({ children }) => {
  const selectedExcerpt = useAppSelector(
    state => state.videoReading.selectedExcerpt
  );

  if (!selectedExcerpt)
    return <Navigate to={ACTOR_ROUTES.profile.choose_excerpt.index} />;

  return children;
};
